const Cookies = require("js-cookie");

module.exports = {
  // server: "https://api.proxies.gg",
  server: window.location.href.includes("localhost")
    ? "http://localhost:8000"
    : window.location.href.includes("singlepass")
    ? "https://test-api.singlepass.io"
    : "https://api.proxies.gg",

  discordURL: window.location.href.includes("localhost")
    ? "https://discord.com/api/oauth2/authorize?client_id=891442824371904532&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fdiscord%2Fcallback&response_type=code&scope=identify%20email%20guilds%20guilds.join%20gdm.join%20connections"
    : "https://discord.com/api/oauth2/authorize?client_id=891442824371904532&redirect_uri=https%3A%2F%2Fdashboard.proxies.gg%2Fdiscord%2Fcallback&response_type=code&scope=email%20guilds.join",

  clientId: "891025563014299688",
  config: {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
    },
  },
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  RECAPTCHA_KEY: "6LeFii0pAAAAAEO7wmR6N-feEL2ZQYzQNrUXgVZA",
  GOOGLE_CLIENT_ID:
    "613403665780-hpi6dbrf57do387cs9ug15a8fp4c1dsi.apps.googleusercontent.com",
  checkAccess: (err) => {
    if (err.response) {
      if (err.response.status === 401) {
        Cookies.remove("token");
        window.location.href = "/";
      }
    }
    return true;
  },
};
